export enum ForecastFilterOption {
  dayAndDayAhead = "Day-Day Ahead",
  weekAhead = "1w",
  twoToFourteenDay = "2-14d",
  twoToFiftyTwoWeek = "2-52w",
  twoToOneFiveSixWeek = "2-156w",
}
